import { PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery } from "@/generated/graphql";

// Helper to map label to metricId (simple normalization, adjust as needed)
export const labelToMetricId = (
  label: string,
  positions?: { name?: string | null }[] | null
): string => {
  const normalizedLabel = label.toLowerCase().replace(/ /g, "_");

  // Check if player is a goalkeeper and if the metric is passing
  if (
    normalizedLabel === "passing" &&
    positions?.some(pos => pos.name?.toLowerCase().includes("goalkeeper"))
  ) {
    return "gk_passing";
  }

  return normalizedLabel;
};

// Helper to extract roster values for a given metric
export const getRosterValues = (
  metricLabel: string,
  listPlayerSameTeamAndPosition:
    | PlayerDetailListPlayersByTeamIdsAndPositionIdsQuery
    | undefined,
  positions?: { name?: string | null }[] | null,
  excludePlayerId?: string
): number[] => {
  if (
    !listPlayerSameTeamAndPosition?.listPlayersByTeamIdsAndPositionIds?.edges
  ) {
    return [];
  }

  const isGoalkeeper = positions?.some(pos =>
    pos.name?.toLowerCase().includes("goalkeeper")
  );

  return listPlayerSameTeamAndPosition.listPlayersByTeamIdsAndPositionIds.edges
    .filter(edge => !excludePlayerId || edge?.node?.id !== excludePlayerId)
    .map(edge => {
      const bioData = edge?.node?.bioData;
      if (!bioData) return null;

      // Map label to corresponding bioData field
      switch (metricLabel.toLowerCase()) {
        case "player style fit":
          return bioData.fitScore ? bioData.fitScore * 100 : null;
        case "team style fit":
          return bioData.teamStyleFit ?? null;
        case "gemini player rating":
          return bioData.gpr ?? null;
        case "carrying":
          return bioData.carryingTransGlobalCategoricalScore ?? null;
        case "dribbling":
          return bioData.dribblingTransGlobalCategoricalScore ?? null;
        case "passing":
          // Use goalkeeper passing data for goalkeepers, field player passing for others
          return isGoalkeeper
            ? (bioData.gkPassingTransCategoricalScore ?? null)
            : (bioData.passingTransGlobalCategoricalScore ?? null);
        case "shooting":
          return bioData.shotLocationTransGlobalCategoricalScore ?? null;
        case "positioning":
          return bioData.gkPositioningTransCategoricalScore ?? null;
        case "shot stopping":
          return bioData.gkShotStoppingTransCategoricalScore ?? null;
        case "physical score":
          return bioData.physicalScore ?? null;
        default:
          return null;
      }
    })
    .filter((value): value is number => value !== null);
};
